import _pt from "prop-types";
import React from 'react';
export var ReviewLink = function ReviewLink(props) {
  var handleClick = function handleClick(event) {
    if (props.onClick) {
      props.onClick(event, props.href);
    }
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: props.href,
    onClick: handleClick,
    className: props.className,
    "aria-label": props.ariaLabel
  }, props.children));
};
ReviewLink.propTypes = {
  /**
     * Provide this value to give screenreaders longer, more descriptive text to
     * explain the context of the link.
     */
  ariaLabel: _pt.string,
  className: _pt.string,
  children: _pt.node.isRequired,
  href: _pt.string.isRequired,
  onClick: _pt.func
};
export default ReviewLink;